module.exports = __webpack_public_path__ + "media/packs/site/assets/images/illust_pcsp-a8c3dc5e7589bfc033187c483b3bba1d.png";